<template>
    <div class="productServiceSeting">
        <a-card class="card" title="基本设置" :bordered="false">
            <BaseSet></BaseSet>
        </a-card>
    </div>
</template>

<script>
import BaseSet from "./components/BaseSet";
import $Bus from "@/pages/projectImpl/js/eventBus"
export default {
    name:'ProductServiceSeting',
    components: { BaseSet },
    data () {
        return {

        }
    },
    created () {

    },
    mounted(){
        this.setTitle()
    },
    methods: {
        // 设置当前页面title
        setTitle(){
            const arr = ["首页","内容中心",{name: "产品服务",path: "/content/ContentProductService"},"产品服务配置"];
            $Bus.$emit("pageHeaderBreadcrumb", arr);
        },
    }
}
</script>

<style scoped>
.productServiceSeting{
    width: 100%;
    height: 100%;
}
</style>
